// Mobile
function callback1() {
  function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromInput, toInput, "#ffffff", "#000000", controlSlider);
    if (from > to) {
      fromSlider.value = to;
      fromInput.value = to;
    } else {
      fromSlider.value = from;
    }
    document.querySelector("#fromInput1").innerText = from;
  }

  function controlToInput(toSlider, fromInput, toInput, controlSlider) {
    const [from, to] = getParsed(fromInput, toInput);
    setToggleAccessible(toInput);
    if (from <= to) {
      toSlider.value = to;
      toInput.value = to;
    } else {
      toInput.value = from;
    }
    document.querySelector("#toInput1").innerText = to;
  }

  function controlFromSlider(fromSlider, toSlider, fromInput) {
    const [from, to] = getParsed(fromSlider, toSlider);
    if (from > to) {
      fromSlider.value = to;
      fromInput.value = to;
      document.querySelector("#fromInput1").innerText = to;
    } else {
      fromInput.value = from;
      document.querySelector("#fromInput1").innerText = from;
    }
  }

  function controlToSlider(fromSlider, toSlider, toInput) {
    const [from, to] = getParsed(fromSlider, toSlider);
    setToggleAccessible(toSlider);
    if (from <= to) {
      toSlider.value = to;
      toInput.value = to;
    } else {
      toInput.value = from;
      toSlider.value = from;
    }
    document.querySelector("#toInput1").innerText = to;
  }

  function getParsed(currentFrom, currentTo) {
    const from = parseInt(currentFrom.value, 10);
    const to = parseInt(currentTo.value, 10);
    return [from, to];
  }

  function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
    const rangeDistance = to?.max - to?.min;
    const fromPosition = from?.value - to?.min;
    const toPosition = to?.value - to?.min;
  }

  function setToggleAccessible(currentTarget) {
    const toSlider = document.querySelector("#toSlider1");
    if (Number(currentTarget?.value) <= 0) {
      toSlider.style.zIndex = 2;
    } else {
      toSlider.style.zIndex = 0;
    }
  }

  const fromSlider = document.querySelector("#fromSlider1");
  const toSlider = document.querySelector("#toSlider1");
  const fromInput = document.querySelector(".minPrice");
  const toInput = document.querySelector(".maxPrice");

  if (fromInput?.value) {
    fromSlider.value = fromInput.value;
    document.querySelector("#fromInput1").innerText = fromInput.value;
  }
  if (toInput?.value) {
    toSlider.value = toInput.value;
    document.querySelector("#toInput1").innerText = toInput.value;
  }
  fillSlider(fromSlider, toSlider, "#ffffff", "#000000", toSlider);
  setToggleAccessible(toSlider);
  fromSlider.oninput = () => {
    controlFromSlider(fromSlider, toSlider, fromInput);
  };
  toSlider.oninput = () => {
    controlToSlider(fromSlider, toSlider, toInput);
  };
  fromInput.oninput = () => {
    controlFromInput(fromSlider, fromInput, toInput, toSlider);
  };
  toInput.oninput = () => {
    controlToInput(toSlider, fromInput, toInput, toSlider);
  };
}
callback1();

//
$(document).on("click", ".facets__item, facet-remove", function () {
  setTimeout(function () {
    callback1();
  }, 2000);
});

/*---------- Price Range Filter --------*/
function checkURLChange() {
  var currentURL = window.location.href;
  var protocol = window.location.protocol;
  var host = window.location.host;
  var pathname = window.location.pathname;
  var finalUrl = protocol + "//" + host + pathname;

  setTimeout(function () {
    if (currentURL !== finalUrl) {
      /*-------------------------------------------------------*/
      $(".custom-price-outer1 label").on("click", function () {
        var radioBtn = $(this).find("input[type='radio']");
        radioBtn.prop("checked", true).trigger("change");
      });

      //
      $(".custom-price-outer").on("change", ".sort-radio", function () {
        var sortParam = $(this).val();

        setTimeout(function () {
          console.log("Sorting by: " + sortParam);
          var currentURL = new URL(window.location.href);
          var params = currentURL.searchParams;

          if (!params.has("sort_by") || params.get("sort_by") !== sortParam) {
            params.set("sort_by", sortParam);
            currentURL.search = params.toString();
            var finalURL = currentURL.toString();

            $(".collection").addClass("loading");
            window.history.replaceState({}, document.title, finalURL);

            $.get(finalURL, function (data) {
              var updatedProductGrid = $(data)
                .find("#ProductGridContainer")
                .html();
              $("#ProductGridContainer").html(updatedProductGrid);
              $(".collection").removeClass("loading");
            });
          }
        }, 2000);
      });
      //

      var radioButtonChecked = false;
      function checkRadioButton() {
        if (radioButtonChecked) {
          return;
        }

        var currentURL = new URL(window.location.href);
        var params = currentURL.searchParams;
        var sortParam = params.get("sort_by");

        if (sortParam === "price-ascending") {
          $(".low-to-high").prop("checked", true);
          radioButtonChecked = true;
        } else if (sortParam === "price-descending") {
          $(".high-to-low").prop("checked", true);
          radioButtonChecked = true;
        } else {
          setTimeout(checkRadioButton, 100);
        }
      }
      $(".low-to-high, .high-to-low").change(function () {
        radioButtonChecked = true;
      });
      setTimeout(function () {
        checkRadioButton();
      }, 3000);
      /*---------------------------------------*/

      function callback1() {
        function controlFromInput(
          fromSlider,
          fromInput,
          toInput,
          controlSlider
        ) {
          const [from, to] = getParsed(fromInput, toInput);
          fillSlider(fromInput, toInput, "#ffffff", "#000000", controlSlider);
          if (from > to) {
            fromSlider.value = to;
            fromInput.value = to;
          } else {
            fromSlider.value = from;
          }
          document.querySelector("#fromInput1").innerText = from;
        }

        function controlToInput(toSlider, fromInput, toInput, controlSlider) {
          const [from, to] = getParsed(fromInput, toInput);
          setToggleAccessible(toInput);
          if (from <= to) {
            toSlider.value = to;
            toInput.value = to;
          } else {
            toInput.value = from;
          }
          document.querySelector("#toInput1").innerText = to;
        }

        function controlFromSlider(fromSlider, toSlider, fromInput) {
          const [from, to] = getParsed(fromSlider, toSlider);
          if (from > to) {
            fromSlider.value = to;
            fromInput.value = to;
            document.querySelector("#fromInput1").innerText = to;
          } else {
            fromInput.value = from;
            document.querySelector("#fromInput1").innerText = from;
          }
        }

        function controlToSlider(fromSlider, toSlider, toInput) {
          const [from, to] = getParsed(fromSlider, toSlider);
          setToggleAccessible(toSlider);
          if (from <= to) {
            toSlider.value = to;
            toInput.value = to;
          } else {
            toInput.value = from;
            toSlider.value = from;
          }
          document.querySelector("#toInput1").innerText = to;
        }

        function getParsed(currentFrom, currentTo) {
          const from = parseInt(currentFrom.value, 10);
          const to = parseInt(currentTo.value, 10);
          return [from, to];
        }

        function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
          const rangeDistance = to?.max - to?.min;
          const fromPosition = from?.value - to?.min;
          const toPosition = to?.value - to?.min;
        }

        function setToggleAccessible(currentTarget) {
          const toSlider = document.querySelector("#toSlider1");
          if (Number(currentTarget?.value) <= 0) {
            toSlider.style.zIndex = 2;
          } else {
            toSlider.style.zIndex = 0;
          }
        }

        const fromSlider = document.querySelector("#fromSlider1");
        const toSlider = document.querySelector("#toSlider1");
        const fromInput = document.querySelector(".minPrice");
        const toInput = document.querySelector(".maxPrice");

        if (fromInput?.value) {
          fromSlider.value = fromInput.value;
          document.querySelector("#fromInput1").innerText = fromInput.value;
        }
        if (toInput?.value) {
          toSlider.value = toInput.value;
          document.querySelector("#toInput1").innerText = toInput.value;
        }
        fillSlider(fromSlider, toSlider, "#ffffff", "#000000", toSlider);
        setToggleAccessible(toSlider);
        fromSlider.oninput = () => {
          controlFromSlider(fromSlider, toSlider, fromInput);
        };
        toSlider.oninput = () => {
          controlToSlider(fromSlider, toSlider, toInput);
        };
        fromInput.oninput = () => {
          controlFromInput(fromSlider, fromInput, toInput, toSlider);
        };
        toInput.oninput = () => {
          controlToInput(toSlider, fromInput, toInput, toSlider);
        };
      }
      callback1();

      //
    }
    checkURLChange();
  }, 1000);
}

checkURLChange();

//
$(document).on("click", ".facets__item, facet-remove", function () {
  setTimeout(function () {
    callback1();
  }, 2000);
});

/*---------- Price Range Filter --------*/
function checkURLChange() {
  var currentURL = window.location.href;
  var protocol = window.location.protocol;
  var host = window.location.host;
  var pathname = window.location.pathname;
  var finalUrl = protocol + "//" + host + pathname;

  setTimeout(function () {
    if (currentURL !== finalUrl) {
      /*-------------------------------------------------------*/
      $(".custom-price-outer label").on("click", function () {
        var radioBtn = $(this).find("input[type='radio']");
        radioBtn.prop("checked", true).trigger("change");
      });

      $(".custom-price-outer").on("change", "input[type='radio']", function () {
        var sortValue = $(this).val();
        var sortParam = "";
        if (sortValue === "price-ascending") {
          sortParam = "price-ascending";
        } else if (sortValue === "price-descending") {
          sortParam = "price-descending";
        }

        setTimeout(function () {
          var currentURL = new URL(window.location.href);
          var params = currentURL.searchParams;
          if (!params.has("sort_by") || params.get("sort_by") !== sortParam) {
            params.set("sort_by", sortParam);
            currentURL.search = params.toString();
            var finalURL = currentURL.toString();
            $(".collection").addClass("loading");
            window.history.replaceState({}, document.title, finalURL);

            var currentLocation = window.location.href;
            $.get(currentLocation, function (data) {
              var updatedProductGrid = $(data)
                .find("#ProductGridContainer")
                .html();
              $("#ProductGridContainer").html(updatedProductGrid);
              $(".collection").removeClass("loading");
            });
          }
        }, 2000);
      });

      var radioButtonChecked = false;
      function checkRadioButton() {
        if (radioButtonChecked) {
          return;
        }

        var currentURL = new URL(window.location.href);
        var params = currentURL.searchParams;
        var sortParam = params.get("sort_by");

        if (sortParam === "price-ascending") {
          $(".low-to-high").prop("checked", true);
          radioButtonChecked = true;
        } else if (sortParam === "price-descending") {
          $(".high-to-low").prop("checked", true);
          radioButtonChecked = true;
        } else {
          setTimeout(checkRadioButton, 100);
        }
      }
      $(".low-to-high, .high-to-low").change(function () {
        radioButtonChecked = true;
      });
      setTimeout(function () {
        checkRadioButton();
      }, 3000);
      /*---------------------------------------*/

      function callback1() {
        function controlFromInput(
          fromSlider,
          fromInput,
          toInput,
          controlSlider
        ) {
          const [from, to] = getParsed(fromInput, toInput);
          fillSlider(fromInput, toInput, "#ffffff", "#000000", controlSlider);
          if (from > to) {
            fromSlider.value = to;
            fromInput.value = to;
          } else {
            fromSlider.value = from;
          }
          document.querySelector("#fromInput1").innerText = from;
        }

        function controlToInput(toSlider, fromInput, toInput, controlSlider) {
          const [from, to] = getParsed(fromInput, toInput);
          setToggleAccessible(toInput);
          if (from <= to) {
            toSlider.value = to;
            toInput.value = to;
          } else {
            toInput.value = from;
          }
          document.querySelector("#toInput1").innerText = to;
        }

        function controlFromSlider(fromSlider, toSlider, fromInput) {
          const [from, to] = getParsed(fromSlider, toSlider);
          if (from > to) {
            fromSlider.value = to;
            fromInput.value = to;
            document.querySelector("#fromInput1").innerText = to;
          } else {
            fromInput.value = from;
            document.querySelector("#fromInput1").innerText = from;
          }
        }

        function controlToSlider(fromSlider, toSlider, toInput) {
          const [from, to] = getParsed(fromSlider, toSlider);
          setToggleAccessible(toSlider);
          if (from <= to) {
            toSlider.value = to;
            toInput.value = to;
          } else {
            toInput.value = from;
            toSlider.value = from;
          }
          document.querySelector("#toInput1").innerText = to;
        }

        function getParsed(currentFrom, currentTo) {
          const from = parseInt(currentFrom.value, 10);
          const to = parseInt(currentTo.value, 10);
          return [from, to];
        }

        function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
          const rangeDistance = to?.max - to?.min;
          const fromPosition = from?.value - to?.min;
          const toPosition = to?.value - to?.min;
        }

        function setToggleAccessible(currentTarget) {
          const toSlider = document.getElementById("toSlider1");
          if (Number(currentTarget?.value) <= 0) {
            toSlider?.style.setProperty("z-index", "2");
          } else {
            toSlider?.style.setProperty("z-index", "0");
          }
        }

        const fromSlider = document.querySelector("#fromSlider1");
        const toSlider = document.querySelector("#toSlider1");
        const fromInput = document.querySelector(".minPrice");
        const toInput = document.querySelector(".maxPrice");

        if (fromInput?.value) {
          fromSlider.value = fromInput.value;
          document.querySelector("#fromInput1").innerText = fromInput.value;
        }
        if (toInput?.value) {
          toSlider.value = toInput.value;
          document.querySelector("#toInput1").innerText = toInput.value;
        }
        fillSlider(fromSlider, toSlider, "#ffffff", "#000000", toSlider);
        setToggleAccessible(toSlider);
        fromSlider.oninput = () => {
          controlFromSlider(fromSlider, toSlider, fromInput);
        };
        toSlider.oninput = () => {
          controlToSlider(fromSlider, toSlider, toInput);
        };
        fromInput.oninput = () => {
          controlFromInput(fromSlider, fromInput, toInput, toSlider);
        };
        toInput.oninput = () => {
          controlToInput(toSlider, fromInput, toInput, toSlider);
        };
      }
      callback1();
    }
    checkURLChange();
  }, 1000);
}

checkURLChange();
